import {BackendApi} from '@/services/backend_api'

export default {
  get () {
    return BackendApi.getAnonymousClient().get('indicators')
    .then(response => { return response })
    .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/indicators.js